import { servicesUrlConfig } from "shared/config/setting";

export const joyControlMappingService = {
  async getAll(authFetch, page = 1, perPage = 100) {
    const url = `${servicesUrlConfig.JOY_CONTROL_MAPPINGS_API.get_all}?page=${page}&per_page=${perPage}`;
    return await authFetch(url);
  },

  async create(authFetch, mappingData) {
    return await authFetch(servicesUrlConfig.JOY_CONTROL_MAPPINGS_API.create, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(mappingData),
    });
  },

  async update(authFetch, mappingId, updateData) {
    const url = `${servicesUrlConfig.JOY_CONTROL_MAPPINGS_API.update}${mappingId}`;
    return await authFetch(url, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(updateData),
    });
  },

  async delete(authFetch, mappingId) {
    const url = `${servicesUrlConfig.JOY_CONTROL_MAPPINGS_API.delete}${mappingId}`;
    return await authFetch(url, { method: "DELETE" });
  },
};
